(() => {
  const drawer = document.getElementById('ew-guide-drawer');
  if (!drawer || typeof drawer.showModal !== 'function') return;
  const routes = {
    '/blogs/news/what-size-cake-topper-do-i-need': ['size', 'Will it fit your cake?'],
    '/blogs/news/glitter-vs-mirror-cake-toppers-which-finish-should-you-choose': ['finish', 'Glitter or mirror?']
  };
  let opener = null;
  let openerPath = '';

  // Delegation also covers variant controls replaced by the theme.
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('.ew-buying-help a');
    if (!link) return;
    const path = new URL(link.href, location.href).pathname;
    const guide = routes[path];
    if (!guide) return;
    opener = link;
    openerPath = path;
    drawer.querySelector('#ew-guide-drawer-title').textContent = guide[1];
    drawer.querySelectorAll('[data-ew-guide-panel]').forEach(panel => {
      panel.hidden = panel.dataset.ewGuidePanel !== guide[0];
    });
    // The dialog lives outside the product form; opening it never rebuilds that form.
    drawer.showModal();
    event.preventDefault();
    document.documentElement.classList.add('ew-guide-drawer-open');
    drawer.querySelector('.ew-guide-drawer-body').scrollTop = 0;
  });
  drawer.querySelector('[data-ew-guide-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const bounds = drawer.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
  });
  // Native modal behaviour traps focus, makes the page inert and handles Escape.
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('ew-guide-drawer-open');
    const target = opener?.isConnected ? opener : Array.from(document.querySelectorAll('.ew-buying-help a')).find(link => new URL(link.href, location.href).pathname === openerPath && link.getClientRects().length);
    target?.focus({preventScroll: true});
    opener = null;
  });
})();
